export default {
    footerBackground: '#2c2727',
    lightWhite: 'rgba(255, 255, 255, 0.6)',
    orangeMain: '#ed4848',
};
